import { Datagrid, FunctionField, NumberField, TextField, useGetList, useRecordContext } from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import AddScholarshipBudgetDialog from "./AddScholarshipBudgetDialog";
import UpdateScholarshipBudgetDialog from "./UpdateScholarshipBudgetDialog";
import { Currency } from "utils/constants";
import { scholarshipRequests } from "api/scholarshipApi";
import { Box, CircularProgress } from "@mui/material";

const ScholarshipBudgetExpanded = () => {
  const record = useRecordContext();

  const { data, isLoading } = useGetList(scholarshipRequests.getScholarshipBudgetByYear(record?.fiscalYear), {
    pagination: { page: 1, perPage: 1000 },
  });

  return (
    <>
      {isLoading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          my={4}
        >
          <CircularProgress />
        </Box>
      )}
      {data && (
        <Datagrid
          data={data}
          rowClick={false}
          bulkActionButtons={false}
          sx={{
            "& .RaDatagrid-headerCell": {
              textAlign: "left",
            },
          }}
        >
          <TextField
            source="structuralUnitName"
            label="Факултет"
          />
          <NumberField
            source="amount"
            label="Сума"
            options={{ style: "currency", currency: Currency.EUR }}
            emptyText="-"
            textAlign="left"
          />
          <NumberField
            source="spentAmount"
            label="Изразходвана сума"
            options={{ style: "currency", currency: Currency.EUR }}
            emptyText="-"
            textAlign="left"
          />
          <NumberField
            source="unallocatedAmount"
            label="Неразпределен бюджет"
            options={{ style: "currency", currency: Currency.EUR }}
            emptyText="-"
            textAlign="left"
          />

          <FunctionField
            label=""
            textAlign="center"
            render={rec =>
              rec.hasBudget ? (
                <SecuredComponent permission={permissions.canUpdateScholarshipBudgets}>
                  <UpdateScholarshipBudgetDialog
                    budgetId={rec?.budgetId}
                    structuralUnitName={rec?.structuralUnitName}
                  />
                </SecuredComponent>
              ) : (
                <SecuredComponent permission={permissions.canCreateScholarshiBudgets}>
                  <AddScholarshipBudgetDialog
                    fiscalYear={record.fiscalYear}
                    structuralUnitId={rec?.structuralUnitId}
                    structuralUnitName={rec?.structuralUnitName}
                  />
                </SecuredComponent>
              )
            }
          />
        </Datagrid>
      )}
    </>
  );
};

export default ScholarshipBudgetExpanded;
